<template>
  <v-combobox
    v-model="city"
    :items="cityOptions"
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    auto-select-first
    item-text="CityName"
    item-value="CityName"
    :label="label"
    hide-details
    dense
    :prepend-inner-icon="mdiMapMarker"
    return-object
    no-filter
    :error-messages="errorMessages"
    outlined
    :itemref="itemref"
    clearable
    v-on:click:clear="clear"
    @focus="searchCity()"
    :inputmode="inputmode"
    :disabled="disabled"
  ></v-combobox>
  <!--:multiple="multiple"  :hint="showNeedZoneMessage()" -->
</template>

<script>
import { mdiMapMarker } from "@mdi/js";
import debounce from "lodash/debounce";
import isEmpty from "lodash/isEmpty";
import { SelectCity } from "@/api/publicServices";
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    cachedCitys: {
      type: Array,
    },
    errorMessages: {
      type: String,
    },
    onChange: {
      type: Function,
    },
    itemref: {
      type: String,
      required: true,
    },
    hideDetails: Boolean,
    multiple: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type:Boolean
    }
  },
  data: () => ({
    cityOptions: [],
    isLoading: false,
    search: null,
    city: null,
    isClear: false,

    //svg icons
    mdiMapMarker,
  }),
  computed: {
    inputmode() {
      return  localStorage.getItem("flutter") == "true" || this.$isMobile()?"none":"text";
    },
  },
  created: function () {
    this.debouncedSearchCity = debounce(this.searchCity, 500);
    this.debouncedFilterCachedCity = debounce(this.filterCachedCitys, 500);
  },
  methods: {
    async searchCity(searchVal) {

      console.log(`itemref:${this.itemref}\nclear:${this.isClear}`);
      if (this.isClear) {
        this.isClear = false;
        return;
      }
      if (this.isLoading) return;
      if (
        this.itemref != "" &&
        !isEmpty(this.city) &&
        this.city.CityName === searchVal
      )
        return;
      this.isLoading = true;
      try {
        const response = await SelectCity({
          ZoneName: this.itemref,
          searchVal: searchVal,
        });
        console.log(`response:${response}`)
        this.isLoading = false;
        this.cityOptions = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    filterCachedCitys(searchVal) {
      if (this.isLoading) return;
      if (searchVal.length === 0) return;
      const searchText = searchVal.toLowerCase();
      this.cityOptions = this.cachedCitys.filter((city) => {
        return city.CityName.toLowerCase().indexOf(searchText) > -1;
      });
      this.isLoading = false;
    },
    showNeedZoneMessage() {
      if (this.cityOptions.length == 0) {
        return "need zone";
      } else {
        return "";
      }
    },
    reset() {
      this.cityOptions = [];
      this.city = null;
      // if (this.multiple){
      //   this.city = [];
      // } else {
      //   this.city={};
      // }
    },
    clear() {
      this.isClear = true;
      console.log("isClear");
    },
  },
  watch: {
    search(newVal) {
      if (this.cachedCitys && this.cachedCitys.length > 0) {
        this.debouncedFilterCachedCity(newVal);
      } else {
        this.debouncedSearchCity(newVal);
      }
    },
    city() {
      console.log(this.city);

      this.$emit("input", this.city);
    },
  },
};
</script>
